import React from "react";

import styled from "styled-components/macro";

import FnrButton3 from "UI/FnrButton3";

import SelectList from "./SelectList";

export default function GroupAndReportSelectors({
  groups,
  selectedGroupID,
  handleGroupSelection,
  showGroups,
  toggleGroups,
  reports,
  selectedBoardID,
  handleBoardSelection,
  showReports,
  toggleReports,
  handleClose,
  save,
  isSaving,
}) {
  return (
    <>
      <Options
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <SelectList
          icon="fad fa-users-class"
          label="Group"
          options={groups}
          selectedID={selectedGroupID}
          handleSelection={handleGroupSelection}
          show={showGroups}
          togglePopover={toggleGroups}
        />
        <SelectList
          icon="fad fa-table"
          label="Report"
          options={reports}
          selectedID={selectedBoardID}
          handleSelection={handleBoardSelection}
          placeholder="Select a report"
          show={showReports}
          togglePopover={toggleReports}
        />
      </Options>

      <Row justifyContent="space-between" style={{ marginBlockStart: "4px" }}>
        <FnrButton3 onClick={handleClose} color="gray">
          Cancel
        </FnrButton3>
        <FnrButton3
          onClick={save}
          loading={isSaving}
          disabled={!selectedBoardID || isSaving}
          color="green"
        >
          Save
        </FnrButton3>
      </Row>
    </>
  );
}

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Row = styled.div`
  display: flex;
  justify-content: ${(p) => p.justifyContent || "flex-start"};
  align-items: center;
  gap: 6px;
  padding-inline: ${(p) => p.paddingInline || 0};
`;
